export default __webpack_public_path__ + "static/media/542.f8f4cf5f.gif";